import type { ShopifyCart } from "@redotech/shopify-client/ajax";
import {
  CommercecloudStorefrontClient,
  SfccCart,
} from "./commercecloud-storefront";

export class MarcJacobsStorefrontClient extends CommercecloudStorefrontClient {
  // Shared across instances on the same page (widget + EDD each construct a client).
  private static pendingCartMerge = false;
  private static cartContextRequests = new Set<Promise<SfccCart | undefined>>();
  useCachedCart = false;

  protected override async parseCartResponse(
    response: Response,
  ): Promise<SfccCart> {
    const data = await super.parseCartResponse(response);
    MarcJacobsStorefrontClient.pendingCartMerge ||=
      "mergeBasket" in data && data.mergeBasket === true;
    return data;
  }

  protected override async fetchCart(
    signal?: AbortSignal,
  ): Promise<SfccCart | undefined> {
    const request = super.fetchCart(signal);
    MarcJacobsStorefrontClient.cartContextRequests.add(request);
    try {
      return await request;
    } finally {
      MarcJacobsStorefrontClient.cartContextRequests.delete(request);
    }
  }

  override async cartGet(signal?: AbortSignal): Promise<ShopifyCart> {
    const cart = await super.cartGet(signal);
    await Promise.allSettled(MarcJacobsStorefrontClient.cartContextRequests);
    return cart;
  }

  consumeCartMerge(): boolean {
    const merged = MarcJacobsStorefrontClient.pendingCartMerge;
    MarcJacobsStorefrontClient.pendingCartMerge = false;
    return merged;
  }
}
